import React, { useState, useEffect } from "react";
import Cookies from "universal-cookie";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const cookies = new Cookies();

  useEffect(() => {
    const cookieConsent = cookies.get("cookieConsent");
    if (!cookieConsent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    cookies.set("cookieConsent", "accepted", { path: "/", maxAge: 31536000 }); // 1 year
    setShowBanner(false);
  };

  const handleDecline = () => {
    cookies.set("cookieConsent", "declined", { path: "/", maxAge: 31536000 }); // 1 year
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div style={styles.banner}>
        <p style={styles.paragraph}>
          We use cookies to improve user experience. By clicking 'Accept,' you
          consent to our use of cookies. Learn more in our{" "}
          <a className="cookieLink" style={styles.cookieLink} href="/cookie-policy">Cookie Policy</a>.
        </p>
        <button onClick={handleAccept} style={styles.acceptButton}>
          Accept
        </button>
        <button onClick={handleDecline} style={styles.declineButton}>
          Decline
        </button>
      </div>
    )
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    color: "#fff",
    padding: "15px",
    textAlign: "center",
  },
  paragraph: {
    fontSize: "20px",
  },
  cookieLink: {
    fontSize: "20px",
  },
  acceptButton: {
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    padding: "10px 20px",
    margin: "5px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "10px",
    fontFamily: "'Montserrat', sans-serif",
  },
  declineButton: {
    backgroundColor: "#d9534f",
    color: "white",
    border: "none",
    padding: "10px 20px",
    margin: "5px",
    cursor: "pointer",
    fontSize: "16px",
    borderRadius: "10px",
    fontFamily: "'Montserrat', sans-serif",
  },
};

export default CookieBanner;
